import axios from 'axios';
import React, { createContext, useState, useEffect, useContext } from 'react';

const HabitsContext = createContext();

export const HabitsProvider = ({ apiUrl, children }) => {
  const [habits, setHabits] = useState([]);

  useEffect(() => {
    const fetchHabits = () => {
      const fullHabitsUrl = `${apiUrl}/habits`;
      axios
        .get(fullHabitsUrl, { withCredentials: true })
        .then((response) => {
          console.log('Received habits list:', response.data);
          setHabits(response.data);
        })
        .catch((error) => {
          console.log('Error fetching habits:', error);
          setHabits([]);
        });
    };

    fetchHabits();
  }, [apiUrl]);

  return (
    <HabitsContext.Provider value={{ habits, setHabits }}>
      {children}
    </HabitsContext.Provider>
  );
};

export const useHabits = () => useContext(HabitsContext);
